import { css } from 'emotion';

const mediaBody = css`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 10px 20px;
`;

const mediaPlayer = css`
  width: 100%;
  height: auto;
  border-radius: 5px;
  min-height: 300px;
`;

export default {
  mediaPlayer,
  mediaBody,
};
